import { render, staticRenderFns } from "./ActiveBooking.vue?vue&type=template&id=59e6e0bf&"
import script from "./ActiveBooking.vue?vue&type=script&lang=ts&"
export * from "./ActiveBooking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/vercel/path0/components/Btn.vue').default})
